/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.05.2016.
 */

import MultiscreenDevices from './multistcreen-devices';

export default MultiscreenDevices;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/MultiscreenDevices/index.js